function validMove(maze, visited, newX, newY, width, height) {
    // Check for going off the maze edges
    if (newX < 0 || newX >= width) {
        return false;
    }
    if (newY < 0 || newY >= height) {
        return false;
    }
    // Check for walls
    if (maze[newY][newX] === 1) {
        return false;
    }
    // Check for previous visit
    if (visited[newY][newX] === 1) {
        return false;
    }
    return true;
}

function search(maze, visited, x, y, width, height) {
    // eslint-disable-next-line no-param-reassign
    visited[y][x] = 1;

    // Check 4 ways
    if (validMove(maze, visited, x, y - 1, width, height)) {
        search(maze, visited, x, y - 1, width, height);
    }
    if (validMove(maze, visited, x, y + 1, width, height)) {
        search(maze, visited, x, y + 1, width, height);
    }
    if (validMove(maze, visited, x - 1, y, width, height)) {
        search(maze, visited, x - 1, y, width, height);
    }
    if (validMove(maze, visited, x + 1, y, width, height)) {
        search(maze, visited, x + 1, y, width, height);
    }

    return visited;
}

function useVisitedMaze(answers, { cols = 4, rows = 4, squareSize = 3 } = {}) {
    const grid = [];
    const visited = [];

    const fullCols = cols * squareSize + 2;
    const fullRows = rows * squareSize + 2;

    let startX = 0;
    let startY = 0;

    let i;
    let j;
    let k;
    let l;
    let m;
    let n;
    let answer;
    let source;
    let value;

    for (i = 0; i < fullCols; i += 1) {
        for (j = 0; j < fullRows; j += 1) {
            if (!grid[i]) {
                grid[i] = [];
            }
            if (!visited[i]) {
                visited[i] = [];
            }
            visited[i][j] = 0;
            if (i === 0 || i === fullCols - 1 || j === 0 || j === fullRows - 1) {
                if (i === 0 && j === 2) {
                    grid[i][j] = 2;
                    startX = j;
                    startY = i;
                } else if (i === fullCols - 1 && j === fullRows - 3) {
                    grid[i][j] = 3;
                } else {
                    grid[i][j] = 1;
                }
            } else {
                grid[i][j] = 0;
            }
        }
    }

    for (k = 0; k < cols; k += 1) {
        for (l = 0; l < rows; l += 1) {
            answer = (answers || []).shift();
            source = answer.split('_');
            // AKA Four sides, open or closed
            // 3x3 Squares
            for (m = 0; m < squareSize; m += 1) {
                for (n = 0; n < squareSize; n += 1) {
                    value = 1;
                    // Line 1
                    if (m === 0) {
                        if (n === 0 || n === 2) {
                            value = 1;
                        } else {
                            value = source[0] === '1' ? 0 : 1;
                        }
                    }
                    // Line 2
                    if (m === 1) {
                        if (n === 0) {
                            value = source[3] === '1' ? 0 : 1;
                        } else if (n === 2) {
                            value = source[1] === '1' ? 0 : 1;
                        } else {
                            value = 0; // Middle is always open
                        }
                    }
                    // Line 3
                    if (m === 2) {
                        if (n === 0 || n === 2) {
                            value = 1;
                        } else {
                            value = source[2] === '1' ? 0 : 1;
                        }
                    }
                    grid[1 + k * squareSize + m][1 + l * squareSize + n] = value;
                    visited[1 + k * squareSize + m][1 + l * squareSize + n] = value;
                }
            }
        }
    }

    search(grid, visited, startX, startY, fullCols, fullRows);

    // View maze
    // visited.map((row) => console.log(JSON.stringify(row)));

    const squaresVisited = [];
    let itemsVisited = [];
    for (k = 0; k < cols; k += 1) {
        for (l = 0; l < rows; l += 1) {
            itemsVisited = [];
            for (m = 0; m < squareSize; m += 1) {
                for (n = 0; n < squareSize; n += 1) {
                    itemsVisited.push(visited[1 + k * squareSize + m][1 + l * squareSize + n]);
                }
            }
            squaresVisited.push(
                itemsVisited.reduce((acc, it) => {
                    if (it === 0) {
                        return false;
                    }
                    return acc;
                }, true),
            );
        }
    }

    return squaresVisited;
}

export default useVisitedMaze;
